import { IS_SERVER } from '../common';

/**
 * Названия лендингов, для которых логи и метрика всегда должны
 * определяться как мобильное КОМ приложение
 */
export const MOBILE_APP_LANDING_SLUGS = ['alga20000', 'omad500000'];

/**
 * Проверка по url, относится ли текущий лендинг к MOBILE_APP_LANDING_SLUGS
 */
export const isForcedMobileCOM = (pathname = !IS_SERVER && window.location.pathname) =>
  Boolean(pathname) &&
  MOBILE_APP_LANDING_SLUGS.some((name) => pathname.toLowerCase().includes(name));
